<template>
  <div>
    <div class="overlay" @click.prevent="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="new_achievement_box modal_cont" id="wheel_prize_modal">
        <img :src="closeIconSrc" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_notifications_spin_wheel_prize_yeah }}
          <br> {{ getTranslations.home_modals_notifications_spin_wheel_prize_you }} {{ getTranslations[prizeInfo.prizeName] }}</h1>
        <img src="static/images/achievements/prize-spin.svg" class="prize_spin_img">
        <button type="" class="claim_prize" @click="$emit('close')">{{ getTranslations.home_modals_notifications_spin_wheel_prize_continue }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'spin-wheel-prize',
  mixins: [SkinMixin],
  props: {
    prizeInfo: Object,
  },
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/spinwheel/SpinWheelPrize.vue